import { GANGING_SPEC } from '../Constant/jogakSticker.gangSpec';
import { GangingType, JogakStickerGangingItem, PlushGangSpec } from '../types/techPack';
import type { Size } from '../types/up';

// 스티커 사이즈에 맞는 ganging type을 선택
export function chooseGangingType(size: Size, bp_id: number) {
  const specForBp = GANGING_SPEC[bp_id] as
    | Record<string, JogakStickerGangingItem | PlushGangSpec>
    | undefined;

  if (!specForBp) return null;

  const entries = Object.entries(specForBp).filter(([, item]) => !item.is_hidden);

  entries.sort(([, a], [, b]) => a.priority - b.priority);
  for (const [key, { bounding_box_size_mm }] of entries) {
    // 원본 방향
    if (size.width <= bounding_box_size_mm.width && size.height <= bounding_box_size_mm.height) {
      return key;
    }
    // 90도 회전
    if (size.height <= bounding_box_size_mm.width && size.width <= bounding_box_size_mm.height) {
      return key;
    }
  }
  return null;
}

// 회전값 평가
export function evaluateRotation(size: Size, gang_type: GangingType, bp_id: number): number {
  const SIZE_SPEC = GANGING_SPEC[bp_id];
  if (!SIZE_SPEC) {
    throw new Error(`사이즈를 계산할 수 없습니다: ${bp_id}`);
  }
  const gang_spec = SIZE_SPEC[gang_type];

  if (!gang_spec) {
    throw new Error(`유효하지 않은 조판 타입입니다: ${gang_type}`);
  }

  const { bounding_box_size_mm } = gang_spec;

  if (
    size.width <= gang_spec.bounding_box_size_mm.width &&
    size.height <= gang_spec.bounding_box_size_mm.height
  ) {
    return 0;
  }
  if (size.width <= bounding_box_size_mm.height && size.height <= bounding_box_size_mm.width) {
    return 90;
  }
  throw new Error(`유효하지 않은 크기입니다: ${JSON.stringify(size)}`);
}

// 스티커 사이즈 평가 (회전, ganging_type 포함)
export function evaluateStickerSizeWithGangType(
  size: Size,
  bp_id: number,
): Size & { rotate: number; ganging_type: GangingType } {
  const ganging_type = chooseGangingType(size, bp_id);

  if (!ganging_type) {
    throw new Error(`주어진 크기에 대한 유효한 조판을 찾을 수 없습니다. ${JSON.stringify(size)}`);
  }

  const rotate = evaluateRotation(size, ganging_type, bp_id);
  return { ...size, rotate, ganging_type };
}
